/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

// NOTE: This will be replaced by an auto-generated file.
export type FeatureToggle = string

export const FeatureToggle = {
  PHONE_NUMBER_AS_PORSCHE_ID: 'PHONE_NUMBER_AS_PORSCHE_ID' as FeatureToggle,
  HIDE_DEALER_SEARCH: 'HIDE_DEALER_SEARCH' as FeatureToggle,
  SHOW_PREFERRED_COMMUNICATION_CHANNEL: 'SHOW_PREFERRED_COMMUNICATION_CHANNEL' as FeatureToggle,
  SHOW_PROFILE_STATUS_INDICATOR: 'SHOW_PROFILE_STATUS_INDICATOR' as FeatureToggle,
  HIDE_PAYMENT_AND_ORDER_SLICE: 'HIDE_PAYMENT_AND_ORDER_SLICE' as FeatureToggle,
  HIDE_SECONDARY_USER_SLICE: 'HIDE_SECONDARY_USERS_SLICE' as FeatureToggle,
  ALLOW_OWNER_NAME_CHANGE: 'ALLOW_OWNER_NAME_CHANGE' as FeatureToggle,
}
